import { combineReducers } from "redux";

import { travelAgentsDetails } from "./reducer.travelagent"
const travelAgentsDetailsReducers = combineReducers({

  travelAgentsDetails

})
export default travelAgentsDetailsReducers;
